/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU128Decoder,
  getU128Encoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type CreateSpotPoolArgs = {
  swapFeeBps: number;
  positionId: bigint;
  amount0Max: bigint;
  amount1Max: bigint;
  minSharesOut: bigint;
  /**
   * `Pubkey::default()` creates a hookless spot pool (unchanged legacy path).
   * Any other value creates a hooked spot pool whose address commits to the
   * hook program and flags.
   */
  hookProgram: Address;
  hookFlags: number;
};

export type CreateSpotPoolArgsArgs = {
  swapFeeBps: number;
  positionId: number | bigint;
  amount0Max: number | bigint;
  amount1Max: number | bigint;
  minSharesOut: number | bigint;
  /**
   * `Pubkey::default()` creates a hookless spot pool (unchanged legacy path).
   * Any other value creates a hooked spot pool whose address commits to the
   * hook program and flags.
   */
  hookProgram: Address;
  hookFlags: number;
};

export function getCreateSpotPoolArgsEncoder(): FixedSizeEncoder<CreateSpotPoolArgsArgs> {
  return getStructEncoder([
    ['swapFeeBps', getU16Encoder()],
    ['positionId', getU64Encoder()],
    ['amount0Max', getU64Encoder()],
    ['amount1Max', getU64Encoder()],
    ['minSharesOut', getU128Encoder()],
    ['hookProgram', getAddressEncoder()],
    ['hookFlags', getU32Encoder()],
  ]);
}

export function getCreateSpotPoolArgsDecoder(): FixedSizeDecoder<CreateSpotPoolArgs> {
  return getStructDecoder([
    ['swapFeeBps', getU16Decoder()],
    ['positionId', getU64Decoder()],
    ['amount0Max', getU64Decoder()],
    ['amount1Max', getU64Decoder()],
    ['minSharesOut', getU128Decoder()],
    ['hookProgram', getAddressDecoder()],
    ['hookFlags', getU32Decoder()],
  ]);
}

export function getCreateSpotPoolArgsCodec(): FixedSizeCodec<
  CreateSpotPoolArgsArgs,
  CreateSpotPoolArgs
> {
  return combineCodec(
    getCreateSpotPoolArgsEncoder(),
    getCreateSpotPoolArgsDecoder(),
  );
}
